export const MIXPANEL_ATTRIBUTION_CONTEXT_STORAGE_KEY =
  'nordy.mixpanel.attribution_context'
export const MIXPANEL_LAST_NON_DIRECT_STORAGE_KEY =
  'nordy.mixpanel.last_non_direct'
export const MIXPANEL_OAUTH_ATTRIBUTION_STORAGE_KEY =
  'nordy.mixpanel.oauth_attribution'
export const MIXPANEL_ENGAGEMENT_SESSION_STORAGE_KEY =
  'nordy.mixpanel.engagement_session'
export const MIXPANEL_FIRST_VISIT_STORAGE_KEY = 'nordy.mixpanel.first_visit'

export type MixpanelStorage = Pick<
  Storage,
  'getItem' | 'setItem' | 'removeItem'
>

export function safeReadJson<T>(
  storage: MixpanelStorage | null,
  key: string,
  validate: (value: unknown) => value is T
): T | null {
  if (!storage) return null

  try {
    const value: unknown = JSON.parse(storage.getItem(key) ?? 'null')
    return validate(value) ? value : null
  } catch {
    return null
  }
}

export function safeWriteJson(
  storage: MixpanelStorage | null,
  key: string,
  value: unknown
): boolean {
  if (!storage) return false

  try {
    storage.setItem(key, JSON.stringify(value))
    return true
  } catch {
    return false
  }
}

export function safeRemove(storage: MixpanelStorage | null, key: string): void {
  try {
    storage?.removeItem(key)
  } catch {
    return
  }
}
